import {useEffect, useState} from 'react';
import LaporanKerjaLadangCard from './LaporanKerjaLadangCard';
import LaporanKerjaDate from './LaporanKerjaDate';
import LaporanKerjaDetail from './LaporanKerjaDetail';
import axios from 'axios';
import Cookies from 'js-cookie';
import '../../../assets/styles/laporanKerjaLadang.scss';
import {ModalFlexible} from '../../Modal';
import {DateCalendar, LocalizationProvider} from '@mui/x-date-pickers';
import {AdapterMoment} from '@mui/x-date-pickers/AdapterMoment';
import moment from 'moment';
export default function LaporanKerjaLadang({projectCode}) {
  const apiUrl = process.env.REACT_APP_MAIN_URL;
  const [laporanKerja, setLaporanKerja] = useState([]);
  const [step, setStep] = useState(0);
  const [selected, setSelected] = useState(null);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [open, setOpen] = useState(false);
  const [view, setView] = useState('year');
  const handleGetList = async (payload) => {
    try {
      const response = await axios.post(
        `${apiUrl}/task-report/get-by-projek`,
        payload,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${Cookies.get('token')}`,
          },
        },
      );
      setLaporanKerja(response.data.data);
    } catch (error) {
      console.log(error);
    }
  };
  const formatDate = (date) => {
    return (
      date.getFullYear() + '/' + (date.getMonth() + 1) + '/' + date.getDate()
    );
  };

  const handleRenderUI = (step) => {
    switch (step) {
      case 1:
        return <LaporanKerjaDetail data={selected} setStep={setStep} />;
      case 0:
      default:
        return (
          <>
            <LaporanKerjaDate
              startDate={startDate}
              setStartDate={setStartDate}
              endDate={endDate}
              setEndDate={setEndDate}
              setOpen={setOpen}
              setView={setView}
            />
            {laporanKerja.map((item, index) => (
              <LaporanKerjaLadangCard
                key={index}
                taskStatus={item.taskStatus}
                title={item.jenisKerja}
                date={item.created_at}
                onClick={() => {
                  setSelected(item);
                  setStep(1);
                }}
              />
            ))}
          </>
        );
    }
  };

  useEffect(() => {
    const formattedProjectCode = projectCode.toLowerCase().startsWith('f')
      ? projectCode.slice(1)
      : projectCode;
    handleGetList({
      start_date: formatDate(startDate),
      end_date: formatDate(endDate),
      kod_projek: formattedProjectCode,
    });
  }, [startDate, endDate]);
  return (
    <>
      <div className='lk_ctr'>{handleRenderUI(step)}</div>
      {open && (
        <ModalFlexible onClose={() => setOpen(false)}>
          <LocalizationProvider dateAdapter={AdapterMoment}>
            <DateCalendar
              sx={{
                width: '100%',
                margin: 'auto',
                backgroundColor: '#fff',
              }}
              openTo='month'
              views={['year', 'month']}
              value={moment(startDate)}
              onChange={(newValue) => {
                const start = new Date(
                  `${newValue.year()}/${newValue.month() + 1}/01`,
                );
                const lastDate = function (year, month) {
                  return new Date(year, Number(month), 0).getDate();
                };
                setStartDate(start);
                setEndDate(
                  new Date(
                    `${newValue.year()}/${newValue.month() + 1}/${lastDate(
                      newValue.year(),
                      newValue.month() + 1,
                    )}`,
                  ),
                );
                // }
              }}
            />
          </LocalizationProvider>
        </ModalFlexible>
      )}
    </>
  );
}
